

export const frontMatter = {};
export const contentTitle = undefined;



import {jsx as _jsx} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  return _jsx("table", {
    children: _jsx("thead", {
      children: _jsx("tr", {
        children: _jsx("th", {
          align: "center",
          lang: "isv-Latn",
          children: " A B C Č D DŽ E Ě F G H I J K L LJ M N NJ O P R S Š T U V Y Z Ž "
        })
      })
    })
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

